/**
 * 危機管理型JSON取得
 */
import Util from "./../../lib/util";
import Repository from "./../JsonRepository";
import logger from "./../../lib/logger";

const resource = "";
// const timeFormat = "YYYY-MM-DD HH:mm";

export default {
  /**
   * 選択中危機管理型水位計情報取得
   * @param {*} swobsCd 危機管理型水位計番号
   */
  getSelectedMtSwobs(swobsCd) {
    let path = "master/obs/swstg/" + swobsCd + ".json";
    logger.debug("json getSelectedMtSwobs(" + path + ")");
    return Repository.get(`${resource}` + path);
  },
  /**
   * 選択中危機管理型水位計情報取得
   * @param {*} swobsCd 危機管理型水位計番号
   * @param {*} appTime 取得日時
   */
  getSelectedSwstg(swobsCd, appTime) {
    let datePath = Util.formatDate(appTime, "YYYYMMDD/HHmm/");
    if (process.env.NODE_ENV === "development") {
      // ローカルで動作させる場合は日時を指定しない
      datePath = "";
    }
    logger.debug("json getSelectedSwstg(" + datePath + swobsCd + ")");
    return Repository.get(
      `${resource}/tmlist/swstg/` + datePath + swobsCd + ".json"
    );
  },
  /**
   * 選択中簡易カメラ情報取得
   * @param {*} scamId 簡易カメラID
   */
  getSelectedScam(scamId) {
    let path = "master/obs/scam/" + scamId + ".json";
    logger.debug("json getSelectedScam(" + path + ")");
    return Repository.get(`${resource}` + path);
  },
};
